import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { api } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { LoaderComponent } from '../../components/ui';
import FoodComingSoon from './ComingSoon';

/**
 * Pagali Food no site segue o interruptor do Admin (FOOD_APP_VISIVEL, Admin › Pagali Food ›
 * Restaurantes), tal como a app: desligado → «Brevemente» (os administradores vêem o Food
 * para testar); ligado → montra aberta. Antes dependia de REACT_APP_ENV no build — Linda, 23/10.
 */
const FoodGate: React.FC = () => {
  const { user } = useAuth();
  const [aberto, setAberto] = useState<boolean | null>(null);

  useEffect(() => {
    api.get('/public/funcionalidades')
      .then((r) => setAberto(r.data?.data?.food === true))
      .catch(() => setAberto(false));
  }, []);

  if (aberto === null) return <LoaderComponent />;
  if (!aberto && user?.role !== 'PFADM') return <FoodComingSoon />;
  return <Outlet />;
};

export default FoodGate;
